import { Box, Button } from "@adfenix/alexandria";
import { useState } from "react";
import styled, { css } from "styled-components";

import { COOKIE_CONSENT } from "utils/constants";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";

const StyledBox = styled(Box)<{ hide: boolean }>`
  background-color: ${({ theme }) => theme.colors.primary};
  position: fixed;
  width: 100%;
  overflow: hidden;
  z-index: 9999;
  color: ${({ theme }) => theme.colors.white};

  & a {
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.white};
  }

  ${({ hide }) =>
    hide &&
    css`
      visibility: hidden;
      opacity: 0;
      transition: visibility 300ms, opacity 300ms linear;
    `}
`;

const CookiesBar = () => {
  const consent = Cookies.get(COOKIE_CONSENT);
  const [showBanner, setShowBanner] = useState(consent !== "true");

  const { t } = useTranslation();

  const handleOnClick = () => {
    Cookies.set(COOKIE_CONSENT, "true", { expires: 1000 });
    setShowBanner(false);
  };

  return showBanner ? (
    <StyledBox
      p="l"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      hide={!showBanner}
    >
      <span>
        {t("cookie.consent.description")}{" "}
        <a
          aria-label="learn more about cookies"
          data-loglabel="cookie-info-link"
          role="button"
          href="https://www.adfenix.com/cookies"
          target="_blank"
          rel="noreferrer"
        >
          {t("cookie.consent.privacy")}
        </a>
      </span>
      <Button
        variant="secondary"
        onClick={handleOnClick}
        logLabel="cookie-consent-button"
      >
        {t("cookie.consent.button")}
      </Button>
    </StyledBox>
  ) : null;
};

export default CookiesBar;
